/**
 * Power-bar intent heuristic.
 *
 * The Ask Avery bar does double duty: a typed token is usually a LOOKUP (plate,
 * txn id, zone number, a name) the operator wants to search/filter, but it can
 * also be a natural-language QUESTION for Avery ("which zone earned the most?").
 * On a list screen, treating a question as a lookup live-filters the table to
 * nothing as you type — the long-standing "quirk". This classifier lets the bar
 * suppress the in-place filter (and surface the "Ask Avery" action) for
 * questions while keeping the instant filter for real lookups.
 *
 * Deliberately conservative: when unsure, treat input as a LOOKUP (returns
 * false) — the dropdown always offers an explicit "Ask Avery" row as the
 * safety net, so a misjudged lookup costs nothing.
 */

// Leading words that signal a question or a command directed at the assistant.
const QUESTION_WORDS = new Set([
  'which', 'what', 'how', 'why', 'when', 'who', 'whose', 'where',
  'is', 'are', 'was', 'were', 'do', 'does', 'did', 'can', 'could', 'should', 'would',
  'show', 'list', 'find', 'give', 'tell', 'count', 'compare', 'explain', 'summarize',
])

export function looksLikeQuestion(raw: string): boolean {
  const q = raw.trim().toLowerCase()
  if (q.length === 0) return false
  if (q.endsWith('?')) return true
  const words = q.split(/\s+/)
  // Long input reads as prose, not a lookup term.
  if (words.length >= 6 || q.length >= 48) return true
  // Starts with a question / command word ("show me…", "which zone…").
  if (QUESTION_WORDS.has(words[0])) return true
  return false
}
